import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { AssabilMenu } from '../../entities/control-tables/assabil-menu';


export class AssabilMenuRequest extends BaseRequest {
  assabilMenu : AssabilMenu;
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.assabilMenu = new AssabilMenu();
  }
}